import { useState } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  IconButton,
  Box,
} from "@mui/material";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import HomeIcon from "@mui/icons-material/Home";
import CloseIcon from "@mui/icons-material/Close";
import { Link, useLocation } from "react-router-dom";
import { muiPalette } from "../../constants/muiPalette";
import { useLoginState } from "../../hooks/useLoginState";
import StorefrontIcon from "../Icons/StorefrontIcon";
import InventoryIconCustom from "../Icons/Inventory";

const allMenuItems = [
  {
    text: "Home",
    icon: <HomeIcon/>,
    path: "/",
    module: null,
  },
  {
    text: "Performance",
    icon: <StorefrontIcon/>,
    path: "/projects",
    module: "TARGET_SALES",
  },
  {
    text: "Inventory Management",
    icon: <InventoryIconCustom width={24} height={24}/>,
    path: "/inventory-management",
    module: "INVENTORY",
  }
];

export const Menu = () =>
{
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { enabledModules = [] } = useLoginState();

  const menuItems = allMenuItems.filter(
    (item) => item.module === null || enabledModules.includes(item.module)
  );

  const toggleDrawer = (open) => (event) =>
  {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift'))
    {
      return;
    }
    setIsOpen(open);
  };

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <IconButton
        onClick={toggleDrawer(true)}
        sx={{
          padding: 0,
          '&:hover': {
            backgroundColor: 'transparent',
            opacity: 0.7
          }
        }}
      >
        <MenuRoundedIcon sx={{fontSize: "28px", color: muiPalette.gray[100]}}/>
      </IconButton>

      <Drawer
        anchor="left"
        open={isOpen}
        onClose={toggleDrawer(false)}
        sx={{
          '& .MuiDrawer-paper': {
            width: 280,
            boxSizing: 'border-box',
          },
        }}
      >
        <Box
          sx={{width: 280}}
          role="presentation"
        >
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '20px 16px',
            borderBottom: `1px solid ${muiPalette.gray[20]}`
          }}>
            <Box sx={{
              fontSize: '18px',
              fontWeight: 600,
              color: muiPalette.gray[100]
            }}>
              Menu
            </Box>
            <IconButton
              onClick={toggleDrawer(false)}
              sx={{
                padding: '8px',
                '&:hover': {
                  backgroundColor: muiPalette.gray[10]
                }
              }}
            >
              <CloseIcon sx={{fontSize: "20px"}}/>
            </IconButton>
          </Box>

          <List sx={{padding: '12px 0'}}>
            {menuItems.map((item) => (
              <ListItem
                key={item.text}
                disablePadding
                sx={{marginBottom: '4px'}}
              >
                <ListItemButton
                  component={Link}
                  to={item.path}
                  onClick={toggleDrawer(false)}
                  sx={{
                    padding: '12px 16px',
                    margin: '0 8px',
                    borderRadius: '2px',
                    backgroundColor: isActive(item.path) ? muiPalette.gray[100] : 'transparent',
                    color: isActive(item.path) ? '#fff' : muiPalette.gray[100],
                    '&:hover': {
                      backgroundColor: isActive(item.path)
                        ? muiPalette.gray[60]
                        : muiPalette.gray[10],
                    },
                    transition: 'all 0.2s ease-in-out'
                  }}
                >
                  <ListItemIcon sx={{
                    minWidth: '40px',
                    color: isActive(item.path) ? '#fff' : muiPalette.gray[60]
                  }}>
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={item.text}
                    primaryTypographyProps={{
                      fontSize: '15px',
                      fontWeight: isActive(item.path) ? 600 : 500
                    }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </>
  );
};
